import { postRequest, createDateObject } from '@/core';
import { orders } from '@/requests';

export default async function newOrderRequest(order) {
	let url = orders.getPath();
	order.registeredDate = createDateObject();
	let response = await postRequest(url, {},  order);
	return response;
}
